import axios from "axios";

export default {
  getList: (startDate, endDate) => {
    return axios.get(
      `/api/Orders/List?startDate=${startDate}&endDate=${endDate}`,
    );
  },
  getRenewalDetails: (id) => {
    return axios.get("/api/Orders/RenewalDetails/" + id);
  },
  getActivationDetails: (id) => {
    return axios.get("/api/Orders/ActivationDetails/" + id);
  },
  approve: (order) => {
    return axios.post("/api/Orders/Approve/" + order.id);
  },
  reject: (order) => {
    return axios.post("/api/Orders/Reject/" + order.id);
  },
  delete: (order) => {
    return axios.delete("/api/Orders/" + order.id);
  },
  createInvoice: (file) => {
    const formData = new FormData();
    formData.append("xlsxOrders", file);

    return axios.post("/api/Orders/CreateInvoice", formData);
  },
  createSelfInvoice: (xlsxFile, pdfFiles = []) => {
    const formData = new FormData();
    formData.append("xlsxAutofatture", xlsxFile);

    if (pdfFiles && pdfFiles.length > 0) {
      pdfFiles.forEach((file) => {
        formData.append(file.name, file);
      });
    }

    return axios.post("/api/Orders/CreateSelfInvoice", formData);
  },
  importPaymentHistory: (file) => {
    const formData = new FormData();
    formData.append("xlsxPrimaNota", file);
    formData.append("dryRun", false);

    return axios.post("/api/Orders/ImportPaymentHistory", formData);
  },
};
